(function () {
  if (window.tcQuickAddInitialized) return;
  window.tcQuickAddInitialized = true;

  const activeButtons = new WeakSet();
  let cartUpdateInFlight = false;

  function parseSection(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function getCartPageSections() {
    const sections = [];
    const mainItems = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const recommendations = document.querySelector('[data-tc-cart-recommendations][data-section-id]');

    if (mainItems?.dataset.id) {
      sections.push({ id: mainItems.id, section: mainItems.dataset.id, selector: '.js-contents' });
    }
    if (footer?.dataset.id) {
      sections.push({ id: footer.id, section: footer.dataset.id, selector: '.js-contents' });
    }
    if (recommendations) {
      sections.push({
        id: recommendations.id,
        section: recommendations.dataset.sectionId,
        selector: '[data-tc-cart-recommendations]'
      });
    }
    if (document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
        replaceOuter: true
      });
    }

    return sections;
  }

  function renderCartPageSections(response, sections) {
    sections.forEach(function (section) {
      const html = response.sections?.[section.section];
      const current = document.getElementById(section.id);
      const replacement = parseSection(html, section.selector);
      if (!current || !replacement) return;

      if (section.replaceOuter) {
        current.replaceWith(replacement);
        return;
      }

      const target = current.querySelector(section.selector) || current;
      target.innerHTML = replacement.innerHTML;
    });
  }

  function updateCartCount(cartData) {
    const cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink) return;

    let bubble = cartLink.querySelector('.cart-count-bubble');
    if (cartData.item_count === 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartLink.appendChild(bubble);
    }
    bubble.innerHTML = '<span aria-hidden="true">' + cartData.item_count + '</span><span class="visually-hidden">' + cartData.item_count + ' items</span>';
  }

  function announce(message, isError) {
    const feedback = document.querySelector('[data-tc-cart-feedback]');
    if (feedback) {
      window.clearTimeout(feedback.tcHideTimer);
      feedback.textContent = message;
      feedback.hidden = false;
      feedback.toggleAttribute('data-error', Boolean(isError));
      feedback.tcHideTimer = window.setTimeout(function () {
        feedback.hidden = true;
      }, 4000);
    }

    const liveRegion = document.getElementById('cart-live-region-text');
    if (liveRegion) {
      liveRegion.textContent = message;
      liveRegion.setAttribute('aria-hidden', 'false');
      window.setTimeout(function () {
        liveRegion.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  }

  function setButtonState(button, loading) {
    const spinner = button.querySelector('.loading-overlay__spinner');
    button.toggleAttribute('disabled', loading);
    button.setAttribute('aria-disabled', loading ? 'true' : 'false');
    button.classList.toggle('loading', loading);
    spinner?.classList.toggle('hidden', !loading);
  }

  function setCartLoading(line, loading) {
    const mainItems = document.getElementById('main-cart-items');
    mainItems?.classList.toggle('cart__items--disabled', loading);
    document.querySelectorAll('#CartItem-' + line + ' .loading-overlay').forEach(function (overlay) {
      overlay.classList.toggle('hidden', !loading);
    });

    const status = document.getElementById('shopping-cart-line-item-status');
    if (status) status.setAttribute('aria-hidden', loading ? 'false' : 'true');
  }

  function updateCartLine(line, quantity, controlName) {
    if (cartUpdateInFlight) return;

    const sections = getCartPageSections();
    if (!sections.length || !/^\d+$/.test(String(line)) || !/^\d+$/.test(String(quantity))) return;

    cartUpdateInFlight = true;
    setCartLoading(line, true);

    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        sections: sections.map(function (section) { return section.section; }),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok || body.status) {
            throw new Error(body.description || 'Unable to update the cart.');
          }
          return body;
        });
      })
      .then(function (cartData) {
        renderCartPageSections(cartData, sections);
        updateCartCount(cartData);

        const cartItems = document.querySelector('cart-items');
        if (cartItems) {
          cartItems.currentItemCount = cartData.item_count;
          cartItems.classList.toggle('is-empty', cartData.item_count === 0);
        }
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cartData.item_count === 0);

        announce('Cart updated.', false);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));

        if (controlName === 'plus' || controlName === 'minus') {
          window.requestAnimationFrame(function () {
            const row = document.getElementById('CartItem-' + line);
            row?.querySelector('button[name="' + controlName + '"]')?.focus();
          });
        }
      })
      .catch(function (error) {
        const errors = document.getElementById('cart-errors');
        if (errors) errors.textContent = error.message || window.cartStrings.error;
        announce(error.message || window.cartStrings.error, true);
      })
      .finally(function () {
        setCartLoading(line, false);
        cartUpdateInFlight = false;
      });
  }

  document.addEventListener('click', function (event) {
    const removeButton = event.target.closest('cart-items cart-remove-button');
    const quantityButton = event.target.closest('cart-items quantity-input button[name="plus"], cart-items quantity-input button[name="minus"]');
    if (!removeButton && !quantityButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (cartUpdateInFlight) return;

    if (removeButton) {
      updateCartLine(removeButton.dataset.index, 0, 'remove');
      return;
    }

    const input = quantityButton.closest('quantity-input')?.querySelector('[name="updates[]"]');
    if (!input) return;

    const previousValue = input.value;
    quantityButton.name === 'plus' ? input.stepUp() : input.stepDown();
    if (previousValue !== input.value) {
      updateCartLine(input.dataset.index, input.value, quantityButton.name);
    }
  }, true);

  document.addEventListener('change', function (event) {
    const input = event.target.closest('cart-items [name="updates[]"]');
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    updateCartLine(input.dataset.index, input.value, 'input');
  }, true);

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-tc-quick-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || activeButtons.has(button)) return;

    const form = button.closest('form');
    const variantInput = form?.querySelector('input[name="id"]');
    const variantId = String(button.dataset.variantId || button.value || variantInput?.value || '').trim();
    const productTitle = button.dataset.productTitle || 'Item';

    if (!/^\d+$/.test(variantId)) {
      announce('Unable to add this bottle. Please refresh and try again.', true);
      return;
    }

    if (variantInput) {
      variantInput.disabled = false;
      variantInput.value = variantId;
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const cartPageSections = getCartPageSections();
    const payload = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (cartPageSections.length) {
      payload.sections = cartPageSections.map(function (section) { return section.section; });
      payload.sections_url = window.location.pathname;
    } else if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    activeButtons.add(button);
    setButtonState(button, true);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok || body.status) {
            throw new Error(body.description || 'Unable to add this bottle.');
          }
          return body;
        });
      })
      .then(function (response) {
        if (cartPageSections.length && response.sections) {
          renderCartPageSections(response, cartPageSections);
        } else if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }

        return fetch(window.routes.cart_url + '.js', {
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (cartResponse) {
          if (!cartResponse.ok) throw new Error('Unable to refresh the cart.');
          return cartResponse.json();
        });
      })
      .then(function (cartData) {
        updateCartCount(cartData);

        const cartItems = document.querySelector('cart-items');
        if (cartItems) {
          cartItems.currentItemCount = cartData.item_count;
          cartItems.classList.toggle('is-empty', cartData.item_count === 0);
        }
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cartData.item_count === 0);

        announce(productTitle + ' added to cart.', false);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      })
      .catch(function (error) {
        announce(error.message || 'Unable to add this bottle.', true);
      })
      .finally(function () {
        activeButtons.delete(button);
        if (button.isConnected) setButtonState(button, false);
      });
  });
})();
